/* eslint-disable no-unused-vars */
/* eslint-disable no-new */


import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router/router'
import FastClick from 'fastclick'
import GLOBAL from '../static/global'

import POPUP from './utils/popup'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import { Lazyload } from 'vant';
import VueClipboard from 'vue-clipboard2'


Vue.use(VueClipboard)

import Popup from './components/popup/index'
Vue.prototype.$popup = Popup.install
Vue.use(AlertPlugin)
Vue.use(Lazyload);

Vue.use(Lazyload, {
lazyComponent: true,
});
Vue.config.productionTip = false
Vue.prototype.GLOBAL = GLOBAL
Vue.prototype.POPUP = POPUP
FastClick.attach(document.body) 
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js